import React, { useState, useRef, useMemo, useImperativeHandle } from 'react';
import classnames from 'classnames/bind';
import { ResizableBox } from 'react-resizable';
import { inWindow, apiHolder } from 'api';
import styles from './CollapsibleList.module.scss';
import IconCard from '@web-common/components/UI/IconCard';
const systemApi = apiHolder.api.getSystemApi();
const realStyle = classnames.bind(styles);
export const CollapsibleList = React.forwardRef((props, ref) => {
    const { style, innerStyle, children, placement = 'left', onChange, needBtn = false, resizable = false, minConstraints, maxConstraints, defaultWidth = 200, title = '', onOpen = () => { }, onClose = () => { }, defaultVisible, } = props;
    const [visible, setVisible] = useState(defaultVisible !== undefined ? !!defaultVisible : true);
    const wrapperRef = useRef(null);
    useImperativeHandle(ref, () => ({
        controlAsideVisible: (value) => setVisible(value),
    }));
    const renderResizable = () => (React.createElement(ResizableBox, { width: defaultWidth, height: Infinity, axis: "x", resizeHandles: ['nw'], minConstraints: minConstraints, maxConstraints: maxConstraints }, children));
    const btnIconType = useMemo(() => {
        if (placement === 'left') {
            return visible ? 'tongyong_zhankai_zuo' : 'tongyong_zhankai_you';
        }
        else {
            return visible ? 'tongyong_zhankai_you' : 'tongyong_zhankai_zuo';
        }
    }, [visible, placement]);
    const [btnIconStroke, setBtnIconStroke] = useState('#8D92A1');
    const renderBtn = () => (React.createElement("div", { onMouseEnter: () => {
            setBtnIconStroke('#4C6AFF');
        }, onMouseLeave: () => {
            setBtnIconStroke('#8D92A1');
        }, onClick: () => {
            setVisible(!visible);
            setBtnIconStroke('#8D92A1');
            Promise.resolve().then(() => {
                if (wrapperRef.current != null) {
                    onChange && onChange(visible ? wrapperRef.current.offsetWidth : 0, visible ? wrapperRef.current.offsetHeight : 0);
                }
            });
            visible ? onClose() : onOpen();
        }, className: `dark-svg-invert ${realStyle(Object.assign({ btn: true }, (placement === 'left'
            ? {
                closeBtn: visible,
                openBtn: !visible,
            }
            : {
                closeBtnRight: visible,
                openBtnRight: !visible,
            })))}` },
        React.createElement(IconCard, { type: btnIconType, stroke: btnIconStroke })));
    return (React.createElement("div", { ref: wrapperRef, className: realStyle({
            collapsibleList: true,
            needBtn: needBtn,
        }), style: Object.assign(Object.assign({}, (style !== null && style !== void 0 ? style : {})), (visible
            ? {}
            : {
                width: 0,
            })) },
        needBtn && inWindow() && renderBtn(),
        React.createElement("div", { style: innerStyle || {}, hidden: !visible, className: realStyle({
                myResizable: resizable,
                fullHeight: systemApi.isWebWmEntry(),
            }) }, resizable ? renderResizable() : children)));
});
